//performance reducer
import {
  SET_PERFORMANCE_DATA,
  ADD_PERFORMANCE_DATA,
  UPDATE_PERFORMANCE_DATA,
  SET_ADD_DIALOG_OPEN,
  SET_EDIT_DIALOG_OPEN,
  SET_EDIT_DATA,
  PerformanceActionTypes,
} from "../types/performanceTypes";
import { PerformanceState } from "../types/performanceTypes";

const initialState: PerformanceState = {
  performanceData: [],
  addDialogOpen: false,
  editDialogOpen: false,
  editData: null,
};

const performanceReducer = (
  state = initialState,
  action: PerformanceActionTypes
): PerformanceState => {
  switch (action.type) {
    case SET_PERFORMANCE_DATA:
      return {
        ...state,
        performanceData: action.payload,
      };
    case ADD_PERFORMANCE_DATA:
      return {
        ...state,
        performanceData: Array.isArray(action.payload)
          ? [...state.performanceData, ...action.payload]
          : state.performanceData, // Optional: handle the case where payload is not an array
      };

    case UPDATE_PERFORMANCE_DATA:

    console.log(action.payload.index, action.payload.data,'updateupdate');
    
      return {
        ...state,
        performanceData: state.performanceData.map((item, index) =>
          index === action.payload.index ? action.payload.data : item
        ),
      };
    case SET_ADD_DIALOG_OPEN:
      return {
        ...state,
        addDialogOpen: action.payload,
      };
    case SET_EDIT_DIALOG_OPEN:
      return {
        ...state,
        editDialogOpen: action.payload,
      };
    case SET_EDIT_DATA:
      return {
        ...state,
        editData: action.payload,
      };
    default:
      return state;
  }
};

export default performanceReducer;